import React, { useState } from 'react'
import { addToCart, addToDesires, removeCartItem, removeDesiresItem } from '../../actions'
import { useDispatch, useSelector } from 'react-redux'
import MoreIconButtonCurrentId from '../button/MoreIconButtonCurrentId'
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder'
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart'
import { setShowModalCart } from '../../reducers/cart.reducer'

const MoreIconFunctionalityProduct = ({
    obj,
}) => {
    const [closeMenu, setCloseMenu] = useState(false)

    const { cartItems } = useSelector((state) => state.cart)
    const { desiresItems } = useSelector((state) => state.desires)
    const dispatch = useDispatch()

    const productId = obj?.productId || obj?.product?._id || obj?.product || obj?._id || ''
    const cartItemId = obj?.cartItemId || ''
    const isCartContext = obj?.menuContext === 'cart' || Boolean(cartItemId)

    const actionItem = {
        ...obj,
        _id: productId,
        productId,
        cartItemId
    }

    const handleAddToCart = (item) => {
        dispatch(setShowModalCart())

        const payload = {
            _id: item?.productId || item?._id,
            fullName: item?.fullName || item?.name || item?.picture?.name || 'Товар',
            img: item?.reducedImage || item?.img || item?.picture?.img || item?.mainImage || ''
        }

        dispatch(addToCart(payload))
        setCloseMenu(false)
    }

    const handleRemoveCartItem = (item) => {
        dispatch(removeCartItem({
            cartItemId: item?.cartItemId || cartItemId,
            productId: item?.productId || productId
        }))
        setCloseMenu(false)
    }

    const handleDisableLike = (id) => {
        dispatch(removeDesiresItem({ productId: id || productId }))
        setCloseMenu(false)
    }

    const handleAddToDesires = (product) => {
        dispatch(addToDesires({ _id: product?.productId || product?._id || productId }))
        setCloseMenu(false)
    }

    const itemSettingArray = [
        {
            title: 'Добавить в желаемое',
            icon: <FavoriteBorderIcon />,
            onClick: handleAddToDesires,
            onClickDisable: handleDisableLike,
            activeAddButtonItems: desiresItems,
            activeId: productId,
            titleAdd: 'Уже добавлено'
        },
        {
            title: isCartContext ? 'Удалить из корзины' : 'Добавить в корзину',
            icon: <ShoppingCartIcon />,
            activeAddButtonItems: cartItems,
            activeId: isCartContext ? cartItemId : productId,
            onClick: isCartContext ? handleRemoveCartItem : handleAddToCart,
            onClickDisable: handleRemoveCartItem,
            forceAction: isCartContext,
            titleAdd: 'Удалить из корзины'
        }
    ]

    return (
        <div>
            <MoreIconButtonCurrentId
                objId={productId}
                item={actionItem}
                itemArray={itemSettingArray}
                closeMenu={closeMenu}
                setCloseMenu={setCloseMenu}
            />
        </div>
    )
}

export default MoreIconFunctionalityProduct